module.exports = __webpack_public_path__ + "img/vipp3.36aa32e0.gif";